import React, { useState, useEffect } from 'react';
import { Minimize2, Maximize2, Sparkles } from 'lucide-react';

const ChatInterface = () => {
  const [isFullscreen, setIsFullscreen] = useState(false);
  const [mounted, setMounted] = useState(false);
  const stackAIUrl = "https://www.stackai.com/chat/6982d8a19c65fa231b40649e-2QCEFw8M8LiLfgekXxe0wt";
  const logoUrl = "/delhi-metro-logo.png";

  useEffect(() => {
    setMounted(true);
  }, []);

  return (
    <div className="chat-container">
      {/* Animated Background Elements */}
      <div className="bg-gradient-orb orb-1"></div>
      <div className="bg-gradient-orb orb-2"></div>
      <div className="bg-gradient-orb orb-3"></div>
      
      <div className={`chat-wrapper ${isFullscreen ? 'fullscreen' : ''} ${mounted ? 'mounted' : ''}`}>
        {/* Decorative Header Accent */}
        <div className="header-accent"></div>
        
        {/* Header */}
        <div className="chat-header">
          <div className="chat-header-left">
            <div className="chat-icon-container">
              <div className="chat-icon">
                <img src={logoUrl} alt="Delhi Metro Logo" className="chat-logo" />
              </div>
              <div className="icon-glow"></div>
            </div>
            <div className="chat-header-text">
              <h1 className="chat-title">
                Maintenance Intelligence & Troubleshooting Application
              </h1>
              <div className="chat-status">
                <span className="status-indicator"></span>
                <span className="status-text">Online</span>
                <Sparkles className="sparkle-icon" size={14} />
              </div>
            </div>
          </div>
          <button 
            className="fullscreen-btn"
            onClick={() => setIsFullscreen(!isFullscreen)}
            aria-label={isFullscreen ? "Exit fullscreen" : "Enter fullscreen"}
          >
            {isFullscreen ? <Minimize2 size={20} /> : <Maximize2 size={20} />}
          </button>
        </div>

        {/* Chat Frame with Glass Effect */}
        <div className="chat-frame-container">
          <div className="chat-frame-glow"></div>
          <iframe
            src={stackAIUrl}
            className="chat-iframe"
            title="AI Chat Assistant"
            allow="microphone https://www.stackai.com; camera https://www.stackai.com; clipboard-read; clipboard-write"
            sandbox="allow-same-origin allow-scripts allow-forms allow-popups allow-popups-to-escape-sandbox allow-modals"
          />
        </div>
      </div>
    </div>
  );
};

export default ChatInterface;
